/**
 * @fileoverview Displays active toast notifications. The `ToastContainer` component renders a list of `Toast` components based on the `ToastItem` type and provides a function to remove toasts using the `onRemove` function.
 */

import React from 'react'
import Toast from './Toast'
import type { ToastItem } from '../../hooks/useToast'
import '../../styles/components/Toast.css'

interface ToastContainerProps {
  toasts: ToastItem[]
  onRemove: (id: string) => void
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {
  if (toasts.length === 0) return null

  return (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          duration={toast.duration}
          targetElement={toast.targetElement}
          onClose={() => onRemove(toast.id)}
        />
      ))}
    </>
  )
}

export default ToastContainer
